import {handleActions} from 'redux-actions';
import actions from './suggestions.actions';

const reducer = handleActions(
	{
		[actions.suggestionsStarted]: state => ({
			...state,
			started: true
		}),
		[actions.suggestionsStopped]: state => ({
			...state,
			started: false
		}),
		[actions.suggestionsLoaded]: (state, {payload}) => ({
			...state,
			items: payload.reduce(
				(accum, community) =>
					accum
						.concat([
							{
								...community,
								type: 'community',
								suggestedMembers: null
							}
						])
						.concat(community.suggestedMembers),
				[]
			),
			communities: [...payload],
			current: 0,
			next: null
		}),
		[actions.suggestionsNextStart]: state => ({
			...state,
			next: (state.current + 1) % state.items.length
		}),
		[actions.suggestionsNextEnd]: state => ({
			...state,
			current: state.next,
			next: null
		})
	},
	{
		// Default
		items: [],
		current: 0,
		next: null,
		started: false
	}
);

export default reducer;



// WEBPACK FOOTER //
// ./src/profile/suggestions.reducer.js